exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".playerInfoBackground{background-repeat:no-repeat;background-size:cover;background-position:center}.playerInfoCard{display:-webkit-flex;display:flex;-webkit-flex-direction:row;flex-direction:row;-webkit-align-items:center;align-items:center;flex-wrap:wrap;opacity:1.0 !important}.playerInfoImage{margin:3px;padding:10px 0 0 10px}.infoCard{display:inline-block;vertical-align:top;padding:0 0 0 5px;-moz-box-sizing:border-box;-webkit-box-sizing:border-box;box-sizing:border-box}.infoCard p{padding-left:3rem;margin:0 0 10px}.infoCard .infoLabel{color:#999;padding-right:5px}.playerInfoName{margin-top:1rem;margin-left:3rem}.playerInfoFooter{background:inherit;border:0}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/dist/cjs.js!./src/components/PlayerDetails/PlayerDetails.scss
// module id = 321
// module chunks = 0